'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = require('react');

var _reactUtils = require('react-utils');

var _hubspotReagan = require('hubspot.reagan.reagan');

var _hubspotReagan2 = _interopRequireDefault(_hubspotReagan);

var _CheckerStore = require('../CheckerStore');

var _CheckerStore2 = _interopRequireDefault(_CheckerStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var reagan = null;
var initialPageLoad = true;

function configure(options) {
  if (reagan) {
    (0, _reactUtils.invariant)(reagan === null, 'Reagan can only be configured once');
  }

  // If the first argument quacks like a Bucky instance, explicitly pass it and statsPath.
  // Otherwise, pass the first argument as options wholesale
  if (options && options.send && options.timer && options.timer.stopwatch) {
    throw new Error('Bucky is deprecated and no longer needed for Reagan. Don\'t pass it to the configure call. And unless you are passing custom Reagan options, you don\'t need to call configure at all anymore.');
  } else {
    reagan = new _hubspotReagan2.default(options);
  }
}

function checker() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$checkOnChange = _ref.checkOnChange,
      checkOnChange = _ref$checkOnChange === undefined ? true : _ref$checkOnChange,
      _ref$selectors = _ref.selectors,
      selectors = _ref$selectors === undefined ? undefined : _ref$selectors,
      _ref$metricGroup = _ref.metricGroup,
      metricGroup = _ref$metricGroup === undefined ? undefined : _ref$metricGroup;

  // Note, allowing the checker to be created even if Reagan isn't fully setup
  // (e.g. `selectors` is empty), so that we let higher up code send data on routes
  // that have Reagan misconfigured

  if ((typeof selectors === 'undefined' ? 'undefined' : _typeof(selectors)) !== 'object' && typeof console !== 'undefined' && console.error) {
    console.error('Reagan Checker requires DOM element selectors be specified');
  }

  if (metricGroup) {
    console.warn('The Reagan Checker metricGroup option is deprecated, use names or paths on your routes instead');
  }

  return function wrapWithChecker(WrappedComponent) {
    var ReaganChecker = function (_Component) {
      _inherits(ReaganChecker, _Component);

      function ReaganChecker(props, context) {
        _classCallCheck(this, ReaganChecker);

        // Use context as a dependeny injection mechanism to have once reference
        // to a `checkerStore` per component tree. And keep track of which component
        // is the "highested" checker to ensure only once `reaganCheck()` is called
        // per component tree.
        var _this = _possibleConstructorReturn(this, (ReaganChecker.__proto__ || Object.getPrototypeOf(ReaganChecker)).call(this, props, context));

        if (context && context.checkerStore) {
          _this.checkerStore = context.checkerStore;
          _this.isTopMostCheckerComponent = false;
        } else {
          _this.checkerStore = new _CheckerStore2.default();
          _this.isTopMostCheckerComponent = true;
        }

        _this.checkerStore.addMoreChecks({ checkOnChange: checkOnChange, selectors: selectors });
        return _this;
      }

      _createClass(ReaganChecker, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          var location = this.props.location;

          // Automatically call configure if it hasn't been called (since there are
          // now no required configure arguments)

          if (!reagan) {
            configure();
          }

          if (this.isTopMostCheckerComponent && checkOnChange) {
            var componentName = WrappedComponent.displayName || WrappedComponent.name;
            var debugHelper = componentName ? ' on ' + componentName : '';

            (0, _reactUtils.invariant)(checkOnChange && location, 'A location prop is needed for Reagan to run checks on route changes' + debugHelper + '. Some suggestions...\n  - Are the react-router props (location, route, routes) getting through to the first Checker HOC in the React component chain?\n  - Maybe you want to pass `checkOnChange: false` in the Checker configuration and only want a Reagan check to happen on mount?');
          }

          // Send the route name to New Relic if they are setup
          this.notifyNewRelicOfRouteName();
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          // Only ever call reaganCheck() once per component tree
          if (this.isTopMostCheckerComponent) {
            this.reaganCheck();
          }
        }
      }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate() {
          this.notifyNewRelicOfRouteName();
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          var location = this.props.location;

          // Note, CheckerStore will ensure that all checker HOCs in the component tree will agree on
          // `checkOnChange`. So it is OK to only call `regeanCheck()` from the topmost checker

          if (this.isTopMostCheckerComponent && checkOnChange && nextProps.location !== location) {
            this.reaganCheck(false);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          // Remove the checks this component provided
          this.checkerStore.removeExistingChecks(selectors);

          if (this.isTopMostCheckerComponent) {
            reagan.stop();
          }
        }
      }, {
        key: 'getChildContext',
        value: function getChildContext() {
          return { checkerStore: this.checkerStore };
        }
      }, {
        key: 'notifyNewRelicOfRouteName',
        value: function notifyNewRelicOfRouteName() {
          var nameForRoute = this.getNameForRoute();

          if (this.isTopMostCheckerComponent && this.lastRouteName != nameForRoute) {
            this.lastRouteName = nameForRoute;

            if (window.newrelic && window.newrelic.setCurrentRouteName) {
              window.newrelic.setCurrentRouteName(nameForRoute);
              window.newrelic.setCustomAttribute('route', nameForRoute);
            }
          }
        }

        // If any of the routes in the nested "route path" have a `name`, use that (the deepest one).
        // Otherwise if there are multiple routes that have a `path`, join them all in to a single name `path1/path2/path3`

      }, {
        key: 'getNameForRoute',
        value: function getNameForRoute() {

          // The checker HOC passes along a setCustomRouteName prop components can use to
          // manually set the route name (and prevent/overwrite any route name autodetection)
          if (this.checkerStore.hasCustomRouteName()) {
            return this.checkerStore.getCustomRouteName();
          }

          var _props = this.props,
              route = _props.route,
              routes = _props.routes;

          // Support for react-router 0.13.2 (v2 internally)

          if (!routes && this.context && this.context.router && this.context.router.getCurrentRoutes) {
            routes = this.context.router.getCurrentRoutes();
            route = routes[routes.length - 1];
          }

          if (routes) {
            // Join the name/path of whole "route path" together
            var routeNames = routes.map(function (currRoute) {
              return currRoute && currRoute.name;
            }).filter(function (str) {
              return !!str;
            });
            var routePathTokens = routes.map(function (currRoute) {
              return currRoute && currRoute.path;
            }).filter(function (str) {
              return str;
            });
            var cleanRoutePathTokens = routePathTokens.filter(function (str) {
              return str !== '/';
            }).map(function (str) {
              return str.replace(/^\/?|\/?$/, '');
            });

            if (routeNames.length > 0) {
              return routeNames[routeNames.length - 1];
            } else if (cleanRoutePathTokens.length > 0) {
              return cleanRoutePathTokens.join('/');
            } else {
              return routePathTokens.join('/');
            }
          } else if (route) {
            return route.name || route.path;
          }
        }
      }, {
        key: 'reaganCheck',
        value: function reaganCheck() {
          var _this2 = this;

          var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

          var options = { startTimerOnPageLoad: initialPageLoad };

          // The first time reaganCheck is ever called is a page load, all others are
          // route changes (requires that we only ever call reaganCheck once per component tree)
          initialPageLoad = false;

          var check = function check() {
            var nameForRoute = _this2.getNameForRoute();
            var checkName = nameForRoute ? nameForRoute : 'unknown-route';

            reagan.check(checkName, _this2.checkerStore.getCombinedSelectors(), options);
          };

          // Only ever allow a single Reagan check to be going at a time. If a user
          // leaves a route before the check finishes, we stop it before starting another
          reagan.stop();

          if (immediate) {
            check();
          } else {
            setTimeout(check, 0);
          }
        }
      }, {
        key: 'render',
        value: function render() {
          return (0, _react.createElement)(WrappedComponent, _extends({}, this.props, {
            setCustomRouteName: this.checkerStore.setCustomRouteName.bind(this.checkerStore)
          }));
        }
      }]);

      return ReaganChecker;
    }(_react.Component);

    ReaganChecker.WrappedComponent = WrappedComponent;
    ReaganChecker.displayName = 'Reagan(' + (0, _reactUtils.getComponentName)(WrappedComponent) + ')';

    var routeType = _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.element]);

    ReaganChecker.propTypes = {
      location: _react.PropTypes.object,
      route: routeType,
      routes: _react.PropTypes.oneOfType([routeType, _react.PropTypes.arrayOf(routeType)])
    };

    ReaganChecker.childContextTypes = {
      checkerStore: _react.PropTypes.object
    };
    ReaganChecker.contextTypes = {
      checkerStore: _react.PropTypes.object,
      router: _react.PropTypes.object
    };

    return ReaganChecker;
  };
}

exports.default = { configure: configure, checker: checker };
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/Reagan/static-6.24/coffee/components/Checker.js
// module id = 467
// module chunks = 0